export default "__VITE_ASSET__b7edf1f8__"